import { action, computed, observable } from 'mobx';
import { observer } from 'mobx-react';
import { autoinject, bind, deepStringFind, inject, ModalHandle, NothingHere, StatusCard } from 'Mri.Web.Common';
import * as React from 'react';
import { Input } from 'reactstrap';
import { ZendeskLinkDropdown } from '../../../Core/ZendeskLinkDropdown';
import { ActiveDisplay } from '../../ActiveDisplay';
import { DisplaysStore } from '../../DisplaysStore';
import { DisplayStatusTicketItem } from './DisplayStatusTicketItem';
import { TicketModal } from '../../TicketModal';

export interface ITicketsCardProps {
    readonly display: ActiveDisplay;
    readonly loading: boolean;
}

@autoinject
@observer
export class TicketsCard extends React.Component<ITicketsCardProps> {
    public render() {
        return (
            <StatusCard title={this.renderTicketsTitle()} loading={this.props.loading} bodyClassName="h-100">
                <Input
                    type="text"
                    placeholder="Search Tickets..."
                    value={this.searchValue}
                    onChange={this.onSearchInputChange}
                    className="rounded-0 ticket-search"
                />

                <div className="scroll-container mt-3">
                    <div className="scroll-card">
                        {!!this.tickets?.length && (
                            <table className="table w-100">
                                <tbody>
                                    {this.tickets.map(ticket => (
                                        <DisplayStatusTicketItem ticket={ticket} key={ticket.ticketId} />
                                    ))}
                                </tbody>
                            </table>
                        )}

                        <NothingHere
                            empty={!this.tickets?.length}
                            label="No Tickets At This Time"
                            loading={this.props.loading}
                        />
                    </div>
                </div>

                {this.props.display && (
                    <TicketModal modalHandle={this.ticketModalHandle} display={this.props.display} />
                )}
            </StatusCard>
        );
    }

    @bind
    private renderTicketsTitle() {
        return (
            <div>
                <span className="me-2">Support Tickets</span>
                <div className="d-inline-block">
                    <ZendeskLinkDropdown
                        size="sm"
                        serialNumber={this.props.display.serialNumber}
                        className="me-2 ms-0"
                    />
                    <a onClick={this.openTicketModal} className="btn btn-primary btn-sm">
                        Submit Ticket
                    </a>
                </div>
            </div>
        );
    }

    @computed
    private get tickets() {
        let tickets = this.displaysStore.openTickets.get(this.props.display.serialNumber);
        if (this.searchValue && tickets) tickets = tickets.filter((o: any) => deepStringFind(o, this.searchValue));
        return tickets;
    }

    @bind
    private openTicketModal(event?: React.MouseEvent<HTMLAnchorElement>) {
        if (event) event.preventDefault();
        this.ticketModalHandle.open();
    }

    @bind
    @action
    private onSearchInputChange(event: React.FormEvent<HTMLInputElement>) {
        const target = event.target as HTMLInputElement;
        this.searchValue = target.value;
    }

    private ticketModalHandle = new ModalHandle();
    @observable
    private searchValue: string = '';
    @inject
    private displaysStore!: DisplaysStore;
}
